<app-side-menu>
  
  <div class="positions-container">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <button 
          class="btn btn-secondary me-2"
          (click)="goBack()">
          <i class="fas fa-arrow-left me-2"></i>
          Voltar
        </button>
        <div>
          <h2 class="mb-0 d-inline">
            Cargos do Departamento: {{ department?.name || 'Carregando...' }}
          </h2>
          <p class="text-muted mb-0" *ngIf="department?.managerStaffName">
            <i class="fas fa-user-tie me-1"></i>
            Gerente: {{ department?.managerStaffName }}
            <span *ngIf="department?.managerStaffRegistration"> ({{ department?.managerStaffRegistration }})</span>
          </p>
        </div>
      </div>
      <button
        *appHasPermission="'Positions.Manage'"
        class="btn btn-primary"
        (click)="newPosition()">
        <i class="fas fa-plus me-2"></i>
        Novo Cargo
      </button>
    </div>

    <div *ngIf="error" class="alert alert-danger" role="alert">
      {{ error }}
    </div>

    <div *ngIf="!error">
      <app-table
        [title]="'Lista de Cargos'"
        [data]="positions"
        [columns]="columns"
        [loading]="loading"
        [showSearch]="false"
        [clickable]="false"
        [disablePagination]="true"
        [actions]="actions"
        (actionClick)="onActionClick($event)">
      </app-table>
    </div>
  </div>

</app-side-menu>

